firebird.factory('attendeeService', [
    '$rootScope',
    '$window',
    '$timeout',
    'helperService',
    'socketService',
    'logService',
    'automationService',
    'localStreamManagerService',
    'storageService',
    'localizationService',
    'attendeeStateService',
    'meetingStateService',
    'brandingStateService',
    'attendeeUpgradedService',
    'subscriptionService',
    'settingsStateService',
    function (
        $rootScope,
        $window,
        $timeout,
        helperService,
        socketService,
        logService,
        automationService,
        localStreamManagerService,
        storageService,
        localizationService,
        attendeeStateService,
        meetingStateService,
        brandingStateService,
        attendeeUpgradedService,
        subscriptionService,
        settingsStateService
    ) {
        const logger = logService.createLoggerWithSource('attendeeService');
        var attendantId = 0,
            attendantLoginId = 0,
            email = '',
            userIdentifier = '',
            attendeeType = 'attendee',
            isViewerOnly = false,
            location = '',
            screenName = '',
            imgURL = '',
            isAudioMuted = false,
            token = '',
            videoRoomAppUserId = '',
            isTrusted = false,
            isExternal = false,
            hdScreenShareConfMemberId = 0,
            //This initial value dictates whether or not webcam will be shared on join
            isVideoMuted = true,
            isVideoBlinded = false,
            isAudioDeafed = false,
            // VDI-only - to check if video is stopped when preview is used when call webcam is enabled
            isVideoActive = false,
            broadcastOption = {
                audio: false,
                video: false
            },
            //play prompts on mute/unmute.  see comments in init function
            playMutedPrompt = false,
            onBoardingInfo = null,
            isWaitingForAudioUpdate = false,
            isWaitingForVideoUpdate = false,
            isWaitingForPromoteDemote = false,
            //Phone Pairing
            audioPin = null,
            phoneMemberId = null,
            reconnectingPairId = null,
            completedCallstatSurvey = false,
            useCallstatSurvey = false,
            //This is here because attendeeService cannot inject meetingService (which also has a sfuEnabled var)
            sfuEnabled = false,
            rootSubscription,
            isHost = false,
            isHostOrFakeHost = false,
            isPresenter = false,
            isAttendee = false,
            service = {
                init: init,
                getEmail: getEmail,
                getUserIdentifier: getUserIdentifier,
                getAttendantId: getAttendantId,
                getAttendeeType: getAttendeeType,
                getAttendantLoginId: getAttendantLoginId,
                getScreenName: getScreenName,
                getIsHost: getIsHost,
                getIsTrusted: getIsTrusted,
                getIsViewerOnly: getIsViewerOnly,
                setAttendeeType: setAttendeeType,
                getIsPresenter: getIsPresenter,
                getIsAttendee: getIsAttendee,
                setImageURL: setImageURL,
                getImageURL: getImageURL,

                //Phone Pairing
                setAudioPin: setAudioPin,
                getAudioPin: getAudioPin,
                getIsPhonePaired: getIsPhonePaired,
                setPhoneMemberId: setPhoneMemberId,
                getPhoneMemberId: getPhoneMemberId,
                setReconnectingPairId: setReconnectingPairId,
                getReconnectingPairId: getReconnectingPairId,

                setBroadcastOption: setBroadcastOption,
                getBroadcastOption: getBroadcastOption,
                setOnboardingInfo: setOnboardingInfo,
                getOnboardingInfo: getOnboardingInfo,

                setIsAudioMuted: setIsAudioMuted,
                getIsAudioMuted: getIsAudioMuted,
                setIsVideoMuted: setIsVideoMuted,
                getIsVideoMuted: getIsVideoMuted,
                setIsVideoBlinded: setIsVideoBlinded,
                getIsVideoBlinded: getIsVideoBlinded,
                getIsAudioDeafed: getIsAudioDeafed,
                toggleAudio: toggleAudio,
                toggleVideo: toggleVideo,
                toggleVideoOff: toggleVideoOff,
                setVideoBlind: setVideoBlind,
                setAudioDeaf: setAudioDeaf,
                audioMuteAll: audioMuteAll,
                kick: kick,
                removeVirtualAssistant: removeVirtualAssistant,

                setIsWaitingForAudioUpdate: setIsWaitingForAudioUpdate,
                getIsWaitingForAudioUpdate: getIsWaitingForAudioUpdate,

                setIsWaitingForVideoUpdate: setIsWaitingForVideoUpdate,
                getIsWaitingForVideoUpdate: getIsWaitingForVideoUpdate,

                setIsWaitingForPromoteDemote: setIsWaitingForPromoteDemote,
                getIsWaitingForPromoteDemote: getIsWaitingForPromoteDemote,

                setToken: setToken,
                getToken: getToken,
                getAttendantBearerToken: getAttendantBearerToken,
                getAttendeeSocketLoginData: getAttendeeSocketLoginData,

                getCompletedCallstatSurvey: getCompletedCallstatSurvey,
                setCompletedCallstatSurvey: setCompletedCallstatSurvey,

                shouldUseCallstatSurvey: shouldUseCallstatSurvey,

                setHDScreenShareConfMemberId: setHDScreenShareConfMemberId,
                getHDScreenShareConfMemberId: getHDScreenShareConfMemberId,

                getMutedPromptSettingState: getMutedPromptSettingState,
                setMutedPromptSettingState: setMutedPromptSettingState,

                getIsExternal: getIsExternal,
                setIsVideoActive: setIsVideoActive,
                getIsVideoActive: getIsVideoActive,

                // functions based on new angular
                getIsSfuEnabled: getIsSfuEnabled,
                getLocation: getLocation
            };

        initSubscriptions();

        $rootScope.$on('audio-updated', onAudioUpdated);
        $rootScope.$on('video-updated', onVideoUpdated);
        $rootScope.$on('deaf-state-updated', onDeafStateUpdated);
        $rootScope.$on('phone-pairing-state-updated', onPhonePairingStateUpdated);
        $rootScope.$on('callstat-userpair', onCallstatUserPair);
        $rootScope.$on('attendee-partial-property', onAttendeePartialProperty);
        $rootScope.$on('$destroy', onScopeDestroyed);

        return service;

        ////////////////////////

        function getCompletedCallstatSurvey() {
            return completedCallstatSurvey;
        }

        function setCompletedCallstatSurvey(completed) {
            completedCallstatSurvey = completed;
        }

        function shouldUseCallstatSurvey() {
            return useCallstatSurvey && !helperService.isMobile();
        }

        function onCallstatUserPair(e, data) {
            useCallstatSurvey = data.useCallstatSurvey;
        }

        function init(attendeeObj) {
            logger.log('Init attendeeService with:', attendeeObj.attendantId);

            attendeeStateService.attendantId = attendeeObj.attendantId;
            attendeeStateService.attendantLoginId = attendeeObj.attendantLoginId;
            attendeeStateService.email = attendeeObj.email;
            attendeeStateService.userIdentifier = attendeeObj.userIdentifier;
            setAttendeeType(attendeeObj.attendeeType);
            isViewerOnly = helperService.getQueryParameter('viewerOnly') === 'true' ? true : false;
            attendeeStateService.location = attendeeObj.location;
            attendeeStateService.screenName = attendeeObj.screenName;
            attendeeStateService.token = attendeeObj.token;
            attendeeStateService.videoRoomAppUserId = attendeeObj.videoRoomAppUserId;
            attendeeStateService.isTrusted = attendeeObj.isTrusted;
            attendeeStateService.isExternal = attendeeObj.isExternal;

            $rootScope.$on('promoted-to-presenter', onPromotedToPresenter);
            $rootScope.$on('demoted-to-attendee', onDemotedToAttendee);

            initMutedPromptSettingState(attendeeObj.isWebinar);
        }

        //Most of our local client settings are read/initialized in the settings controller.  However,  most of back services
        //that have single default states that are known before the settings screen would be open.  This setting however, is dynamic
        //based on if a user can be detectedt to have used our platform before.  Also, it's init state didn't want to be tied to controller
        //logic that may defer it's init in the future before we would need to mute/ummute.  Hence, the reading of this setting here.
        function initMutedPromptSettingState(isWebinar) {
            if (isWebinar) {
                logger.log('Setting playMutedPrompt to true for webinar');
                playMutedPrompt = true;
                settingsStateService.playMutedPrompt = playMutedPrompt;
                return;
            }

            //technical debt to remove these clean up calls
            storageService.remove('mutedAudioPrompt');
            storageService.remove('mutedAudioPrompt2');

            var previousLocale = storageService.get('selectedLocale');
            var currentLocale = localizationService.getLocalization();
            if (previousLocale && previousLocale !== currentLocale) {
                if (currentLocale.toLowerCase() !== 'ja-jp') {
                    //reset mute/unmute ivr playback setting
                    playMutedPrompt = true;
                    settingsStateService.playMutedPrompt = playMutedPrompt;
                }
            } else {
                if (
                    storageService.get('playMutedPrompt') !== null &&
                    storageService.get('playMutedPrompt') !== undefined
                ) {
                    playMutedPrompt = !!storageService.get('playMutedPrompt');
                    settingsStateService.playMutedPrompt = playMutedPrompt;
                } else {
                    if (currentLocale.toLowerCase() !== 'ja-jp') {
                        playMutedPrompt = true;
                        settingsStateService.playMutedPrompt = playMutedPrompt;
                    }
                }
            }

            storageService.set('playMutedPrompt', playMutedPrompt);
            storageService.set('selectedLocale', currentLocale);
        }

        function getMutedPromptSettingState() {
            return playMutedPrompt;
        }

        function setMutedPromptSettingState(flag) {
            playMutedPrompt = flag;
            settingsStateService.playMutedPrompt = playMutedPrompt;
            storageService.set('playMutedPrompt', playMutedPrompt);
        }

        function setToken(newToken) {
            attendeeStateService.token = newToken;
        }

        function getToken() {
            return token;
        }

        function getAttendantBearerToken() {
            return 'Bearer ' + service.getToken();
        }

        function getAttendeeSocketLoginData() {
            var attendeeSocketLoginData = {
                attendeeType: service.getAttendeeType(),
                token: service.getToken(),
                email: service.getEmail(),
                userIdentifier: service.getUserIdentifier(),
                attendantId: service.getAttendantId(),
                location: service.getLocation(),
                screenName: service.getScreenName(),
                attendantLoginId: service.getAttendantLoginId(),
                hasWebRTC: helperService.browserHasWebRTC(),
                isMobileAppUser: helperService.isMobile(),
                resellerId: brandingStateService.resellerId,
                supportsE2EE: helperService.hasSupportForE2EE(),
                isTrusted: service.getIsTrusted(),
                isExternal: service.getIsExternal()
            };

            if (helperService.isVideoRoomApplication()) {
                logger.log('detected video room application in getAttendeeSocketLoginData');
                attendeeSocketLoginData.videoRoomAppType = 'display';
                attendeeSocketLoginData.videoRoomAppUserId = videoRoomAppUserId;
            }

            return attendeeSocketLoginData;
        }

        function getAttendantId() {
            return attendantId;
        }

        function getAttendeeType() {
            return attendeeType;
        }

        function getAttendantLoginId() {
            return attendantLoginId;
        }

        function getEmail() {
            return email;
        }

        function getUserIdentifier() {
            return userIdentifier;
        }

        // extracted in attendee.service.ts
        function getIsHost(allowFakeHost) {
            return allowFakeHost ? isHostOrFakeHost : isHost;
        }

        // extracted in attendee.service.ts
        function getIsPresenter() {
            return isPresenter;
        }

        // extracted in attendee.service.ts
        function getIsAttendee() {
            return isAttendee;
        }

        function getIsTrusted() {
            return isTrusted;
        }

        function getIsViewerOnly() {
            return isViewerOnly;
        }

        function getScreenName() {
            return screenName;
        }

        function getImageURL() {
            return imgURL;
        }

        function setImageURL(newImgURL) {
            imgURL = newImgURL;
        }

        function onAttendeePartialProperty(e, data) {
            if (
                !data ||
                data.attendantId !== service.getAttendantId() ||
                data.propName !== 'imageURL' ||
                !data.propValue
            ) {
                return;
            }

            imgURL = data.propValue;
        }

        function setAttendeeType(type) {
            attendeeStateService.attendeeType = type;
        }

        function setAudioPin(newAudioPin) {
            audioPin = newAudioPin;
        }

        function getAudioPin() {
            return audioPin;
        }

        function getBroadcastOption() {
            return broadcastOption;
        }

        function setBroadcastOption(newBroadcastOption) {
            broadcastOption = newBroadcastOption;

            var msgObject = {
                message: 'set-broadcast-option',
                data: broadcastOption
            };

            socketService.send(msgObject);
        }

        function getOnboardingInfo() {
            if (onBoardingInfo) {
                return onBoardingInfo;
            } else {
                //attendees will not have onboarding info
                return { email: service.getEmail() };
            }
        }

        function setOnboardingInfo(newOnboardingInfo) {
            onBoardingInfo = newOnboardingInfo;
        }

        function onPromotedToPresenter(evt) {
            setAttendeeType('presenter');
            isWaitingForPromoteDemote = true;
            $rootScope.$broadcast(
                'notification-service-show',
                localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.YOU_ARE_NOW_A_PRESENTER'),
                'success'
            );
            $rootScope.$broadcast('attendee-type-updated', { newType: 'presenter' });
        }

        function onDemotedToAttendee(evt) {
            setAttendeeType('attendee');
            isWaitingForPromoteDemote = true;
            $rootScope.$broadcast(
                'notification-service-show',
                localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.YOU_ARE_NO_LONGER_A_PRESENTER'),
                'success'
            );
            $rootScope.$broadcast('attendee-type-updated', { newType: 'attendee' });
        }

        function setIsAudioMuted(newVal) {
            isAudioMuted = newVal;
        }

        function getIsAudioMuted() {
            return isAudioMuted;
        }

        function onAudioUpdated(e, data) {
            if (service.getAttendantId() === data.attendantId) {
                logger.log('Updating audio mute state to:', data.isSelfMuted);

                service.setIsAudioMuted(data.isSelfMuted);
                storageService.set('inMeetingAudioState', data.isSelfMuted);
                automationService.getAudioState().audioMuted = data.isSelfMuted;
                service.setIsWaitingForAudioUpdate(false);
                $rootScope.$broadcast('update-local-audio-state');
            }
        }

        function setIsVideoMuted(newVal) {
            isVideoMuted = newVal;
            service.setIsVideoActive(newVal);
        }

        function getIsVideoMuted() {
            return isVideoMuted;
        }

        function onVideoUpdated(e, data) {
            if (service.getAttendantId() === data.attendantId) {
                logger.log('Updating video mute state to:', data.isMuted);

                service.setIsVideoMuted(data.isMuted);
                storageService.set('inMeetingVideoState', data.isMuted);
                automationService.getAudioState().videoMuted = data.isMuted;

                if (service.getIsSfuEnabled()) {
                    $rootScope.$broadcast('update-meeting-active-feed');
                    return;
                }

                if (data.isMuted) {
                    localStreamManagerService.stopLocalVideoTrack();
                    $rootScope.$broadcast('update-meeting-active-feed');
                } else {
                    localStreamManagerService
                        .initLocalVideoTrack(service.getIsVideoMuted())
                        .then(function (isDynamicSet) {
                            //Local Video Tracks aspect ratio is decided by the best
                            //width and height supported by the webcam in use.
                            //
                            //Could be 4:3, 16:9, etc.
                            //
                            //Here, we force 16:9 for consistency
                            if (!isDynamicSet) {
                                localStreamManagerService.setAspectRatio('1.777777778');
                            }
                            $rootScope.$broadcast('update-meeting-active-feed');
                        })
                        .catch(function (err) {
                            logger.error('onVideoUpdated', 'error in initLocalVideoTrack', err);
                            service.toggleVideoOff();

                            $window.swal({
                                title: localizationService.translate('SCREENSHARE.DIALOG.PROBLEM_ACCESSING_WEBCAM'),
                                text: localizationService.translate('SCREENSHARE.DIALOG.PROBLEM_ACCESSING_HOW_TO_FIX'),
                                confirmButtonText: localizationService.translate('COMMON.CLOSE_TEXT'),
                                imageUrl: 'img/redesign/modal/pop-up-pic-warning.svg'
                            });
                        });
                }
            }
        }

        function onDeafStateUpdated(e, data) {
            if (service.getAttendantId() === data.attendantId) {
                logger.log('Received from Meeting Server - updating deaf state to:', data.isAudioDeafed);
                isAudioDeafed = data.isAudioDeafed;
            }
        }

        //When muting/umuting ourselves, send a flag to the client representing our settings for playing the audio prompt
        function toggleAudio(id) {
            logger.log('Toggle audio for member:', id);

            var playPrompt = true;

            if (service.getAttendantId() === id) {
                playPrompt = playMutedPrompt;
                service.setIsWaitingForAudioUpdate(true);
            }

            socketService.send({
                message: 'toggle-attendee-audio',
                data: { attendantId: id, playPrompt: playPrompt },
                callback: function () {
                    service.setIsWaitingForAudioUpdate(false);
                }
            });
        }

        function toggleVideoOff(notificationMessage) {
            if (!service.getIsVideoMuted()) {
                if (notificationMessage) {
                    $rootScope.$broadcast('notification-service-show', notificationMessage, 'success');
                }
                service.toggleVideo();
            }
        }

        function toggleVideo() {
            var newVMuteState = !service.getIsVideoMuted();

            logger.log('toggling vmute to new value:', newVMuteState);

            if (service.getIsSfuEnabled()) {
                // broadcast some event to videoroom ctrl.
                if (newVMuteState) {
                    $rootScope.$broadcast('stop-sfu-videopublish');
                } else {
                    $rootScope.$broadcast('start-sfu-videopublish');
                }
            } else {
                service.setIsWaitingForVideoUpdate(true);

                socketService.send({
                    message: 'video-mute',
                    data: newVMuteState
                });
            }
        }

        function setIsVideoBlinded(newVal) {
            isVideoBlinded = newVal;
        }

        function getIsVideoBlinded() {
            return isVideoBlinded;
        }

        function getIsAudioDeafed() {
            return isAudioDeafed;
        }

        function setVideoBlind(blind, callback) {
            socketService.send({
                message: 'video-blind',
                data: { blind: blind },
                callback: function () {
                    //TODO: Set this value based on response from Server
                    service.setIsVideoBlinded(blind);

                    if (callback) {
                        callback();
                    }
                }
            });
        }

        function setAudioDeaf(deaf) {
            logger.log('Setting audio deaf to:', deaf);

            socketService.send({
                message: 'audio-deaf',
                data: { deaf: deaf },
                callback: function () {
                    logger.log('Successfully set audio deaf to:', deaf);
                    isAudioDeafed = deaf;
                }
            });
        }

        function audioMuteAll() {
            logger.log('Telling server to mute all attendees');

            socketService.send({
                message: 'audio-mute-all',
                data: {}
            });
        }

        function kick(id) {
            logger.log('Kick member:', id);

            socketService.send({
                message: 'kick-attendee',
                data: { attendantId: id }
            });
        }

        function removeVirtualAssistant() {
            logger.log('starting removeVirtualAssistant');

            socketService.send({
                message: 'kick-virtual-assistant',
                data: {}
            });
        }

        function setIsWaitingForAudioUpdate(newIsWaiting) {
            isWaitingForAudioUpdate = newIsWaiting;
            attendeeStateService.isWaitingForAudioUpdate = newIsWaiting;
        }

        function getIsWaitingForAudioUpdate() {
            return isWaitingForAudioUpdate;
        }

        function setIsWaitingForVideoUpdate(newIsWaiting, isSfuEnabled) {
            logger.log(`setIsWaitingForVideoUpdate: newIsWaiting=${newIsWaiting}, isSfuEnabled=${isSfuEnabled}`);

            if (isSfuEnabled !== service.getIsSfuEnabled()) {
                logger.warn(
                    `setIsWaitingForVideoUpdate incorrect invocation: newIsWaiting=${newIsWaiting}, isSfuEnabled=${isSfuEnabled}`
                );
            }

            isWaitingForVideoUpdate = newIsWaiting;

            if (!isWaitingForVideoUpdate) {
                $rootScope.$broadcast('update-local-video-state');
            }
        }

        function getIsWaitingForVideoUpdate() {
            return isWaitingForVideoUpdate;
        }

        function getIsPhonePaired() {
            return !!phoneMemberId;
        }

        function onPhonePairingStateUpdated(e, data) {
            var phoneMemberId = data && data.phoneMemberId ? data.phoneMemberId : null;
            var pairedPhoneNumber = data && data.pairedPhoneNumber ? data.pairedPhoneNumber : null;
            service.setPhoneMemberId(phoneMemberId);

            $rootScope.$broadcast('local-phone-pairing-state-updated', pairedPhoneNumber);
        }

        function setPhoneMemberId(newPhoneMemberId) {
            phoneMemberId = newPhoneMemberId;
        }

        function getPhoneMemberId() {
            return phoneMemberId;
        }

        function setReconnectingPairId(newReconnectingPairId) {
            reconnectingPairId = newReconnectingPairId;
        }

        function getReconnectingPairId() {
            return reconnectingPairId;
        }

        function setIsWaitingForPromoteDemote(newIsWaitingForPromoteDemote) {
            isWaitingForPromoteDemote = newIsWaitingForPromoteDemote;
        }

        function getIsWaitingForPromoteDemote() {
            return isWaitingForPromoteDemote;
        }

        function setHDScreenShareConfMemberId(newHDScreenShareConfMemberId) {
            logger.log('Setting hdScreenShareConfMemberId to:', newHDScreenShareConfMemberId);
            hdScreenShareConfMemberId = newHDScreenShareConfMemberId;
        }

        function getHDScreenShareConfMemberId() {
            return hdScreenShareConfMemberId;
        }

        function getIsSfuEnabled() {
            return sfuEnabled;
        }

        function getIsExternal() {
            return isExternal;
        }

        function getLocation() {
            return location;
        }

        // VDI-only
        function setIsVideoActive(newVal) {
            isVideoActive = newVal;
        }

        // VDI-only
        function getIsVideoActive() {
            return isVideoActive;
        }

        function onScopeDestroyed() {
            subscriptionService.endSubscription(rootSubscription);
        }

        //#region Angular subscriptions
        function initSubscriptions() {
            rootSubscription = subscriptionService.createSubscription();
            subscribeToState();
            subscribeToCalculatedProperties();
        }

        function subscribeToState() {
            rootSubscription.add(
                attendeeStateService.attendantId$.subscribe(next => {
                    attendantId = next;
                })
            );
            rootSubscription.add(
                attendeeStateService.attendeeType$.subscribe(next => {
                    attendeeType = next;
                })
            );
            rootSubscription.add(
                attendeeStateService.token$.subscribe(next => {
                    token = next;
                })
            );
            rootSubscription.add(
                attendeeStateService.email$.subscribe(next => {
                    email = next;
                })
            );
            rootSubscription.add(
                attendeeStateService.userIdentifier$.subscribe(next => {
                    userIdentifier = next;
                })
            );
            rootSubscription.add(
                attendeeStateService.location$.subscribe(next => {
                    location = next;
                })
            );
            rootSubscription.add(
                attendeeStateService.screenName$.subscribe(next => {
                    screenName = next;
                })
            );
            rootSubscription.add(
                attendeeStateService.attendantLoginId$.subscribe(next => {
                    attendantLoginId = next;
                })
            );
            rootSubscription.add(
                attendeeStateService.isTrusted$.subscribe(next => {
                    isTrusted = next;
                })
            );
            rootSubscription.add(
                attendeeStateService.isExternal$.subscribe(next => {
                    isExternal = next;
                })
            );
            rootSubscription.add(
                attendeeStateService.videoRoomAppUserId$.subscribe(next => {
                    videoRoomAppUserId = next;
                })
            );
            rootSubscription.add(
                attendeeStateService.isWaitingForAudioUpdate$.subscribe(next => {
                    isWaitingForAudioUpdate = next;
                })
            );

            rootSubscription.add(
                meetingStateService.sfuEnabled$.subscribe(next => {
                    sfuEnabled = next;
                })
            );
        }

        function subscribeToCalculatedProperties() {
            rootSubscription.add(
                attendeeUpgradedService.getIsHost$().subscribe(next => {
                    isHost = next;
                })
            );

            rootSubscription.add(
                attendeeUpgradedService.getIsHost$(true).subscribe(next => {
                    isHostOrFakeHost = next;
                })
            );

            rootSubscription.add(
                attendeeUpgradedService.isPresenter$.subscribe(next => {
                    isPresenter = next;
                })
            );

            rootSubscription.add(
                attendeeUpgradedService.isAttendee$.subscribe(next => {
                    isAttendee = next;
                })
            );
        }

        //#endregion
    }
]);
